import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { Button } from 'components/Button'

import * as S from './styled'

type ErrorModalProps = {
  open: boolean
  onClose: () => void
  errorMessages: Record<string, any> | string | null
  fileName?: string
}

export function ErrorModal({
  open,
  onClose,
  errorMessages,
  fileName
}: ErrorModalProps) {
  const { t } = useTranslation()

  const renderErrorContent = () => {
    if (!errorMessages) {
      return (
        <Typography variant="body2" color="textSecondary">
          {t('chargeData:noErrorDetails')}
        </Typography>
      )
    }

    // Se for uma string simples
    if (typeof errorMessages === 'string') {
      return <S.ErrorText>{errorMessages}</S.ErrorText>
    }

    // Se for um objeto, renderizar as chaves e valores
    if (typeof errorMessages === 'object') {
      return (
        <S.ErrorContainer>
          {Object.entries(errorMessages).map(([key, value], index) => (
            <S.ErrorItem key={index}>
              <S.ErrorLabel>{key}:</S.ErrorLabel>
              <S.ErrorValue>
                {typeof value === 'object'
                  ? JSON.stringify(value, null, 2)
                  : String(value)}
              </S.ErrorValue>
            </S.ErrorItem>
          ))}
        </S.ErrorContainer>
      )
    }

    return null
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '12px'
        }
      }}
    >
      <DialogTitle>
        <S.TitleContainer>
          <S.Title>
            {t('chargeData:errorDetails')}
            {fileName && (
              <S.FileName>
                {t('chargeData:file')}: {fileName}
              </S.FileName>
            )}
          </S.Title>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </S.TitleContainer>
      </DialogTitle>

      <DialogContent dividers>
        <S.ContentContainer>{renderErrorContent()}</S.ContentContainer>
      </DialogContent>

      <DialogActions>
        <Button variant="secondary" onClick={onClose} size="medium">
          {t('common:close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ErrorModal
